import React, { useEffect, useState } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import { toast } from "react-toastify";
import loader from "../../methods/loader";
import Layout2 from "../../components/global/layout2";
import { Tag, Tabs, Modal, Input, Descriptions, Badge, Progress, Tooltip } from "antd";
import environment from "../../environment";

const { TextArea } = Input;

const CarrierDossier = () => {
  const { id } = useParams();
  const history = useHistory();
  const [carrier, setCarrier] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");

  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [suspendModal, setSuspendModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [actionNotes, setActionNotes] = useState("");

  useEffect(() => {
    if (id) {
      loadCarrier();
    }
  }, [id]);

  const loadCarrier = () => {
    loader(true);
    ApiClient.get("carrier/profile/" + id).then((res) => {
      if (res.success && res.data) {
        setCarrier(res.data);
      }
      loader(false);
    });
  };

  const handleAction = (action) => {
    if (!actionNotes.trim() && action !== "approve") {
      toast.error("Please provide a reason");
      return;
    }
    loader(true);
    var endpoint;
    if (action === "approve" || action === "reject") {
      endpoint = "admin/carrier/" + id + "/verify";
    } else if (action === "suspend") {
      endpoint = "admin/carrier/" + id + "/suspend";
    } else {
      endpoint = "admin/carrier/" + id + "/verify";
    }
    ApiClient.put(endpoint, {
      action: action,
      notes: actionNotes,
    }).then((res) => {
      if (res.success) {
        toast.success("Carrier " + action + "d successfully");
        setApproveModal(false);
        setRejectModal(false);
        setSuspendModal(false);
        setInfoModal(false);
        setActionNotes("");
        loadCarrier();
      }
      loader(false);
    });
  };

  const getRiskColor = (score) => {
    if (score >= 60) return "#27ae60";
    if (score >= 30) return "#f39c12";
    return "#e74c3c";
  };

  const getRiskLabel = (score) => {
    if (score >= 60) return "Low Risk";
    if (score >= 30) return "Medium Risk";
    return "High Risk";
  };

  const getAuthorityBadge = (status) => {
    if (status === "active") return <Tag color="success">Active Authority</Tag>;
    if (status === "revoked") return <Tag color="error">Revoked</Tag>;
    return <Tag color="warning">Inactive</Tag>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getDaysUntil = (dateStr) => {
    if (!dateStr) return null;
    var now = new Date();
    var target = new Date(dateStr);
    var diff = Math.ceil((target - now) / (1000 * 60 * 60 * 24));
    return diff;
  };

  if (!carrier) {
    return (
      <Layout2 title="Carrier Dossier">
        <div className="mainareas">
          <div className="text-center py-5">
            <p>Loading carrier details...</p>
          </div>
        </div>
      </Layout2>
    );
  }

  var ins = carrier.insurance || {};
  var fmcsa = carrier.fmcsa || {};
  var agreement = carrier.agreement || {};
  var contacts = carrier.contacts || {};
  var fleet = carrier.fleet || {};
  var docs = carrier.documents || [];
  var fraud = carrier.fraud_indicators || [];
  var basics = fmcsa.basic_scores || [];
  var riskScore = carrier.risk_score;

  return (
    <Layout2 title="Carrier Dossier">
      <div className="mainareas">
        <div className="edit-page-common edit-page-commons">
          {/* Header */}
          <div className="row mb-3">
            <div className="col-lg-12">
              <div className="title-head d-flex justify-content-between align-items-center">
                <h3 className="ViewUser mb-0 user-back">
                  <Link to="/onboarding-queue" className="">
                    <i
                      className="fa fa-arrow-left ml-1"
                      title="Back"
                      aria-hidden="true"
                    ></i>
                  </Link>
                  {carrier.company_name || carrier.carrier_name || "Carrier Dossier"}
                  <span style={{ marginLeft: "12px" }}>
                    {getAuthorityBadge(fmcsa.authority_status || carrier.authority_status)}
                  </span>
                </h3>
                <div>
                  <Tag>{carrier.mc_number ? "MC#" + carrier.mc_number : ""}</Tag>
                  <Tag>{carrier.dot_number ? "DOT#" + carrier.dot_number : ""}</Tag>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <Tabs activeKey={activeTab} onChange={setActiveTab} items={[
            {
              key: "overview",
              label: "Overview",
              children: (
              <div className="row">
                {/* Company Info */}
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Company Information</h5>
                    <Descriptions column={1} size="small" bordered>
                      <Descriptions.Item label="Company Name">
                        {carrier.company_name || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="MC#">
                        {carrier.mc_number || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="DOT#">
                        {carrier.dot_number || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Address">
                        {carrier.address || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Phone">
                        {carrier.phone || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Ownership Type">
                        {carrier.ownership_type || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Years in Business">
                        {carrier.years_in_business || "-"}
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </div>

                {/* Risk Score */}
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">TSAP Risk Score</h5>
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                      <div
                        style={{
                          fontSize: "64px",
                          fontWeight: 700,
                          color: getRiskColor(riskScore),
                          lineHeight: 1,
                        }}
                      >
                        {riskScore !== null && riskScore !== undefined ? riskScore : "N/A"}
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          color: getRiskColor(riskScore),
                          marginTop: "8px",
                          fontWeight: 600,
                        }}
                      >
                        {riskScore !== null && riskScore !== undefined
                          ? getRiskLabel(riskScore)
                          : "Not Scored"}
                      </div>
                      {riskScore !== null && riskScore !== undefined && (
                        <Progress
                          percent={riskScore}
                          strokeColor={getRiskColor(riskScore)}
                          showInfo={false}
                          style={{ marginTop: "12px", maxWidth: "300px", margin: "12px auto 0" }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Fraud Indicators */}
                {fraud.length > 0 && (
                  <div className="col-md-12 mb-4">
                    <div className="white-bg-main" style={{ padding: "20px" }}>
                      <h5 className="profilelist mb-3" style={{ color: "#e74c3c" }}>
                        Fraud Indicators
                      </h5>
                      <div className="row">
                        {fraud.map((item, idx) => (
                          <div className="col-md-6 mb-2" key={idx}>
                            <div
                              style={{
                                background: "#fde8e8",
                                borderRadius: "6px",
                                padding: "12px 16px",
                                borderLeft: "4px solid #e74c3c",
                              }}
                            >
                              <div style={{ fontWeight: 600, color: "#e74c3c", fontSize: "14px" }}>
                                {item.title || item.type || "Alert"}
                              </div>
                              <div style={{ fontSize: "13px", color: "#555", marginTop: "4px" }}>
                                {item.description || item.details || "-"}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* FMCSA Data */}
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">FMCSA Data</h5>
                    <Descriptions column={1} size="small" bordered>
                      <Descriptions.Item label="Vehicle Count">
                        {fmcsa.vehicle_count || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Driver Count">
                        {fmcsa.driver_count || "-"}
                      </Descriptions.Item>
                    </Descriptions>
                    {basics.length > 0 && (
                      <div style={{ marginTop: "16px" }}>
                        <h6 style={{ fontWeight: 600, fontSize: "13px" }}>BASIC Scores</h6>
                        {basics.map((b, idx) => (
                          <div
                            key={idx}
                            className="d-flex justify-content-between align-items-center"
                            style={{
                              padding: "6px 0",
                              borderBottom: "1px solid #f0f0f0",
                              fontSize: "13px",
                            }}
                          >
                            <span>{b.name || b.category || "BASIC"}</span>
                            <span style={{ fontWeight: 600 }}>{b.score || b.percentile || "-"}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Contacts */}
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Contacts</h5>
                    <Descriptions column={1} size="small" bordered>
                      <Descriptions.Item label="Primary Contact">
                        {contacts.primary_name || carrier.contact_name || "-"}
                        {contacts.primary_email ? " (" + contacts.primary_email + ")" : ""}
                      </Descriptions.Item>
                      <Descriptions.Item label="Primary Phone">
                        {contacts.primary_phone || carrier.contact_phone || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="After-Hours">
                        {contacts.after_hours_name || "-"}
                        {contacts.after_hours_phone ? " (" + contacts.after_hours_phone + ")" : ""}
                      </Descriptions.Item>
                      <Descriptions.Item label="Billing">
                        {contacts.billing_name || "-"}
                        {contacts.billing_email ? " (" + contacts.billing_email + ")" : ""}
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </div>
              </div>
              ),
            },
            {
              key: "insurance",
              label: "Insurance",
              children: (
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Insurance Verification</h5>
                    <div style={{ marginBottom: "16px" }}>
                      <span style={{ fontWeight: 600, marginRight: "8px" }}>Status:</span>
                      <Tag color={ins.status === "verified" ? "success" : ins.status === "rejected" ? "error" : "processing"}>
                        {ins.status || "Pending"}
                      </Tag>
                    </div>
                    <Descriptions column={1} size="small" bordered>
                      <Descriptions.Item label="Agent Name">
                        {ins.agent_name || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Agent Email">
                        {ins.agent_email || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Agent Phone">
                        {ins.agent_phone || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Agency">
                        {ins.agency_name || "-"}
                      </Descriptions.Item>
                    </Descriptions>
                    {ins.coi_url && (
                      <div style={{ marginTop: "16px" }}>
                        <a
                          href={ins.coi_url.startsWith("http") ? ins.coi_url : environment.api + "documents/" + ins.coi_url}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <i className="fa fa-file-pdf-o me-1"></i> View COI Document
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Coverage Details</h5>
                    <Descriptions column={1} size="small" bordered>
                      <Descriptions.Item label="Auto Liability">
                        {ins.auto_liability_type || "-"} {ins.auto_liability_amount ? "- $" + Number(ins.auto_liability_amount).toLocaleString() : ""}
                      </Descriptions.Item>
                      <Descriptions.Item label="Cargo">
                        {ins.cargo_amount ? "$" + Number(ins.cargo_amount).toLocaleString() : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="General Liability">
                        {ins.general_liability_amount ? "$" + Number(ins.general_liability_amount).toLocaleString() : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Workers Comp">
                        {ins.workers_comp ? "Yes" : "No"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Cert Holder">
                        {ins.cert_holder ? <span style={{ color: "#27ae60" }}>&#10003; Yes</span> : <span style={{ color: "#e74c3c" }}>&#10007; No</span>}
                      </Descriptions.Item>
                      <Descriptions.Item label="Additional Insured">
                        {ins.additional_insured ? <span style={{ color: "#27ae60" }}>&#10003; Yes</span> : <span style={{ color: "#e74c3c" }}>&#10007; No</span>}
                      </Descriptions.Item>
                      <Descriptions.Item label="FMCSA Cross-Reference">
                        {ins.fmcsa_match === true ? <Tag color="success">Match</Tag> : ins.fmcsa_match === false ? <Tag color="error">Mismatch</Tag> : <Tag>N/A</Tag>}
                      </Descriptions.Item>
                      <Descriptions.Item label="NAIC Verification">
                        {ins.naic_valid === true ? <Tag color="success">Valid</Tag> : ins.naic_valid === false ? <Tag color="error">Invalid</Tag> : <Tag>N/A</Tag>}
                      </Descriptions.Item>
                      <Descriptions.Item label="Expiry Date">
                        {formatDate(ins.expiry_date)}
                        {ins.expiry_date && (
                          <span style={{ marginLeft: "8px", color: getDaysUntil(ins.expiry_date) < 30 ? "#e74c3c" : "#27ae60", fontWeight: 600, fontSize: "12px" }}>
                            ({getDaysUntil(ins.expiry_date)} days)
                          </span>
                        )}
                      </Descriptions.Item>
                    </Descriptions>
                    {ins.auto_liability_type === "scheduled" && ins.vin_list && ins.vin_list.length > 0 && (
                      <div style={{ marginTop: "16px" }}>
                        <h6 style={{ fontWeight: 600, fontSize: "13px" }}>VIN List</h6>
                        {ins.vin_list.map(function (vin, idx) {
                          return (
                            <div key={idx} className="d-flex justify-content-between" style={{ padding: "4px 0", borderBottom: "1px solid #f0f0f0", fontSize: "13px" }}>
                              <span style={{ fontFamily: "monospace" }}>{vin.vin || vin}</span>
                              <span>{vin.verified ? <Tag color="success">Verified</Tag> : <Tag color="warning">Pending</Tag>}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 mb-4">
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: "#27ae60", color: "#fff" }}
                      onClick={() => {
                        loader(true);
                        ApiClient.put("admin/insurance/" + id + "/verify", { status: "verified" }).then((res) => {
                          if (res.success) {
                            toast.success("Insurance verified");
                            loadCarrier();
                          }
                          loader(false);
                        });
                      }}
                    >
                      <i className="fa fa-check me-1"></i> Verify Insurance
                    </button>
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: "#e74c3c", color: "#fff" }}
                      onClick={() => {
                        loader(true);
                        ApiClient.put("admin/insurance/" + id + "/verify", { status: "rejected" }).then((res) => {
                          if (res.success) {
                            toast.success("Insurance rejected");
                            loadCarrier();
                          }
                          loader(false);
                        });
                      }}
                    >
                      <i className="fa fa-times me-1"></i> Reject Insurance
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        loader(true);
                        ApiClient.put("admin/insurance/" + id + "/request-resubmit", { type: "insurance" }).then((res) => {
                          if (res.success) {
                            toast.success("Resubmit request sent");
                          }
                          loader(false);
                        });
                      }}
                    >
                      <i className="fa fa-refresh me-1"></i> Request Resubmit
                    </button>
                  </div>
                </div>
              </div>
              ),
            },
            {
              key: "documents",
              label: "Documents",
              children: (
              <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Carrier Documents</h5>
                    {docs.length === 0 ? (
                      <div className="text-center py-4" style={{ color: "#bbb" }}>
                        <i className="fa fa-file-o fa-3x mb-3" style={{ display: "block" }}></i>
                        <p>No documents uploaded</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-sm" style={{ fontSize: "13px" }}>
                          <thead>
                            <tr style={{ background: "#f8f9fa" }}>
                              <th>Document Type</th>
                              <th>File</th>
                              <th>Upload Date</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {docs.map(function (doc, idx) {
                              return (
                                <tr key={doc.id || doc._id || idx}>
                                  <td>
                                    <Tag color="blue">{doc.type || doc.document_type || "Document"}</Tag>
                                  </td>
                                  <td>{doc.filename || doc.name || "File"}</td>
                                  <td>{formatDate(doc.uploaded_at || doc.createdAt)}</td>
                                  <td>
                                    <Tag color={doc.status === "verified" ? "success" : doc.status === "rejected" ? "error" : "processing"}>
                                      {doc.status || "Pending"}
                                    </Tag>
                                  </td>
                                  <td>
                                    {doc.url && (
                                      <a
                                        href={doc.url.startsWith("http") ? doc.url : environment.api + "documents/" + doc.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-outline-primary"
                                        style={{ padding: "1px 8px", fontSize: "11px" }}
                                      >
                                        <i className="fa fa-eye me-1"></i> View
                                      </a>
                                    )}
                                    {doc.url && (
                                      <a
                                        href={doc.url.startsWith("http") ? doc.url : environment.api + "documents/" + doc.url}
                                        download
                                        className="btn btn-sm btn-outline-secondary ms-1"
                                        style={{ padding: "1px 8px", fontSize: "11px" }}
                                      >
                                        <i className="fa fa-download me-1"></i> Download
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              ),
            },
            {
              key: "agreement",
              label: "Agreement",
              children: (
              <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Carrier-Broker Agreement</h5>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <Descriptions column={1} size="small" bordered>
                          <Descriptions.Item label="Status">
                            <Tag color={agreement.status === "active" ? "success" : agreement.status === "expired" ? "error" : "processing"}>
                              {agreement.status || "Not Started"}
                            </Tag>
                          </Descriptions.Item>
                          <Descriptions.Item label="Carrier Signature">
                            {agreement.carrier_signed_at
                              ? formatDate(agreement.carrier_signed_at) + " by " + (agreement.carrier_signer_name || "Carrier")
                              : "Not signed"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Broker Countersign">
                            {agreement.broker_signed_at
                              ? formatDate(agreement.broker_signed_at) + " by " + (agreement.broker_signer_name || "Admin")
                              : "Not countersigned"}
                          </Descriptions.Item>
                          <Descriptions.Item label="Payment Terms">
                            {agreement.payment_terms || "-"}
                          </Descriptions.Item>
                        </Descriptions>
                      </div>
                    </div>
                    {agreement.html && (
                      <div
                        style={{
                          border: "1px solid #eee",
                          borderRadius: "4px",
                          padding: "20px",
                          maxHeight: "400px",
                          overflowY: "auto",
                          background: "#fafafa",
                        }}
                        dangerouslySetInnerHTML={{ __html: agreement.html }}
                      ></div>
                    )}
                    <div className="d-flex gap-2 mt-3">
                      {agreement.status === "pending" && !agreement.broker_signed_at && (
                        <button
                          className="btn btn-sm"
                          style={{ backgroundColor: "#3E549D", color: "#fff" }}
                          onClick={() => {
                            loader(true);
                            ApiClient.put("admin/agreement/" + id + "/countersign", {}).then((res) => {
                              if (res.success) {
                                toast.success("Agreement countersigned");
                                loadCarrier();
                              }
                              loader(false);
                            });
                          }}
                        >
                          <i className="fa fa-pencil me-1"></i> Countersign
                        </button>
                      )}
                      {(agreement.status === "active" || agreement.status === "pending") && (
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => {
                            if (window.confirm("Are you sure you want to terminate this agreement?")) {
                              loader(true);
                              ApiClient.put("admin/agreement/" + id + "/countersign", { action: "terminate" }).then((res) => {
                                if (res.success) {
                                  toast.success("Agreement terminated");
                                  loadCarrier();
                                }
                                loader(false);
                              });
                            }
                          }}
                        >
                          <i className="fa fa-ban me-1"></i> Terminate
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              ),
            },
            {
              key: "fleet",
              label: "Fleet & ELD",
              children: (
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">ELD Connection</h5>
                    <div style={{ marginBottom: "16px" }}>
                      <span style={{ fontWeight: 600, marginRight: "8px" }}>Status:</span>
                      {fleet.eld_connected ? (
                        <Tag color="success">Connected ({fleet.eld_provider || "ELD"})</Tag>
                      ) : (
                        <Tag color="default">Not Connected</Tag>
                      )}
                    </div>
                    {fleet.eld_connected && (
                      <Descriptions column={1} size="small" bordered>
                        <Descriptions.Item label="Provider">
                          {fleet.eld_provider || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Trucks">
                          {fleet.truck_count || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Drivers">
                          {fleet.driver_count || "-"}
                        </Descriptions.Item>
                      </Descriptions>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="white-bg-main" style={{ padding: "20px" }}>
                    <h5 className="profilelist mb-3">Equipment & Lanes</h5>
                    <div style={{ marginBottom: "16px" }}>
                      <h6 style={{ fontWeight: 600, fontSize: "13px" }}>Equipment Types</h6>
                      {fleet.equipment_types && fleet.equipment_types.length > 0 ? (
                        <div className="d-flex flex-wrap gap-1">
                          {fleet.equipment_types.map(function (eq, idx) {
                            return <Tag key={idx}>{eq}</Tag>;
                          })}
                        </div>
                      ) : (
                        <span style={{ color: "#999", fontSize: "13px" }}>None listed</span>
                      )}
                    </div>
                    <div>
                      <h6 style={{ fontWeight: 600, fontSize: "13px" }}>Operating Lanes</h6>
                      {fleet.operating_lanes && fleet.operating_lanes.length > 0 ? (
                        <div>
                          {fleet.operating_lanes.map(function (lane, idx) {
                            return (
                              <div key={idx} style={{ fontSize: "13px", padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                                {lane.origin || lane.from || "-"} &rarr; {lane.destination || lane.to || "-"}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <span style={{ color: "#999", fontSize: "13px" }}>None listed</span>
                      )}
                    </div>
                  </div>
                </div>
                {fleet.freightbridge_scorecard && (
                  <div className="col-md-12 mb-4">
                    <div className="white-bg-main" style={{ padding: "20px" }}>
                      <h5 className="profilelist mb-3">FreightBridge Scorecard</h5>
                      <Descriptions column={2} size="small" bordered>
                        {Object.keys(fleet.freightbridge_scorecard).map(function (key) {
                          return (
                            <Descriptions.Item label={key.replace(/_/g, " ")} key={key}>
                              {fleet.freightbridge_scorecard[key]}
                            </Descriptions.Item>
                          );
                        })}
                      </Descriptions>
                    </div>
                  </div>
                )}
              </div>
              ),
            },
          ]} />

          {/* Bottom Action Bar */}
          <div
            style={{
              borderTop: "1px solid #eee",
              padding: "20px 0",
              marginTop: "20px",
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <button
              className="btn"
              style={{ backgroundColor: "#27ae60", color: "#fff" }}
              onClick={() => setApproveModal(true)}
            >
              <i className="fa fa-check me-1"></i> Approve Carrier
            </button>
            <button
              className="btn"
              style={{ backgroundColor: "#e74c3c", color: "#fff" }}
              onClick={() => setRejectModal(true)}
            >
              <i className="fa fa-times me-1"></i> Reject Carrier
            </button>
            <button
              className="btn"
              style={{ backgroundColor: "#f39c12", color: "#fff" }}
              onClick={() => setSuspendModal(true)}
            >
              <i className="fa fa-pause me-1"></i> Suspend Carrier
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setInfoModal(true)}
            >
              <i className="fa fa-envelope me-1"></i> Request More Info
            </button>
          </div>

          {/* Approve Modal */}
          <Modal
            title="Approve Carrier"
            open={approveModal}
            onOk={() => handleAction("approve")}
            onCancel={() => { setApproveModal(false); setActionNotes(""); }}
            okText="Approve"
            okButtonProps={{ style: { backgroundColor: "#27ae60", borderColor: "#27ae60" } }}
          >
            <p>Are you sure you want to approve this carrier?</p>
            <TextArea
              rows={3}
              placeholder="Notes (optional)"
              value={actionNotes}
              onChange={(e) => setActionNotes(e.target.value)}
            />
          </Modal>

          {/* Reject Modal */}
          <Modal
            title="Reject Carrier"
            open={rejectModal}
            onOk={() => handleAction("reject")}
            onCancel={() => { setRejectModal(false); setActionNotes(""); }}
            okText="Reject"
            okButtonProps={{ style: { backgroundColor: "#e74c3c", borderColor: "#e74c3c" } }}
          >
            <p>Please provide a reason for rejection:</p>
            <TextArea
              rows={3}
              placeholder="Rejection reason (required)"
              value={actionNotes}
              onChange={(e) => setActionNotes(e.target.value)}
            />
          </Modal>

          {/* Suspend Modal */}
          <Modal
            title="Suspend Carrier"
            open={suspendModal}
            onOk={() => handleAction("suspend")}
            onCancel={() => { setSuspendModal(false); setActionNotes(""); }}
            okText="Suspend"
            okButtonProps={{ style: { backgroundColor: "#f39c12", borderColor: "#f39c12" } }}
          >
            <p>Please provide a reason for suspension:</p>
            <TextArea
              rows={3}
              placeholder="Suspension reason (required)"
              value={actionNotes}
              onChange={(e) => setActionNotes(e.target.value)}
            />
          </Modal>

          {/* Request Info Modal */}
          <Modal
            title="Request More Information"
            open={infoModal}
            onOk={() => handleAction("request-info")}
            onCancel={() => { setInfoModal(false); setActionNotes(""); }}
            okText="Send Request"
          >
            <p>What information do you need from the carrier?</p>
            <TextArea
              rows={3}
              placeholder="Describe what information is needed (required)"
              value={actionNotes}
              onChange={(e) => setActionNotes(e.target.value)}
            />
          </Modal>
        </div>
      </div>
    </Layout2>
  );
};

export default CarrierDossier;
